<template>
  <div class="multimedia__content-list">
    <chat-multimedia-empty
      v-if="isEmpty"
      :tab="$t('multimedia.templates')"
      :campaign="selectedCampaignName"
    />
    <div v-else>
      <div class="multimedia__campaign" v-if="isHistory">
        <span>
          {{ $t("multimedia.tab-from", { tab: $t("multimedia.templates") }) }}
        </span>
        <span class="multimedia__campaign-name"
          >{{ selectedCampaignName }}
        </span>
      </div>
      <div
        v-for="(quick, index) in quickText"
        :key="index"
        @click="selectElement(quick)"
        class="multimedia__content-item"
        role="button"
      >
        <div class="multimedia__content-item-text">{{ quick.text }}</div>
      </div>
      <hcc-confirmation />
      <hcc-modal
        class="close-modal"
        :title="modalText['edit-msg']"
        name="send-template-modal"
        @confirm="onConfirmSend"
        @closed="onCloseSend"
        :confirmDisableButton="!isValid"
      >
        <div class="close-modal--body">
          <span class="multimedia__template-text">{{ parseText }}</span>
          <hcc-input
            v-for="(n, i) in paramsForm"
            :key="i"
            class="modal-input"
            :label="getParam(n)"
            v-model.trim="params[i]"
            ref="paramsInput"
          />
        </div>
      </hcc-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  CHAT_MULTIMEDIA_TOGGLE,
  CHAT_SEND_MESSAGE,
} from '@/eventTypes';
import EventBus from '@/eventBus';

export default {
  components: {
    HccModal: () => import('@/components/shared/HccModal/index.vue'),
    HccConfirmation: () => import('@/components/shared/HccConfirmation/index.vue'),
    HccInput: () => import('@/components/shared/HccInput/index.vue'),
    ChatMultimediaEmpty: () => import('@/components/ChatMultimediaEmpty.vue'),
  },
  props: {
    selectedCampaign: {
      type: [String, null],
    },
    selectedCampaignName: {
      type: [String, null],
    },
  },
  data: () => ({
    selectMessage: null,
    params: [],
    type: {
      text: 'tText',
      image: 'tImage',
      document: 'tDocument',
    },
  }),
  computed: {
    ...mapGetters([
      'activeConversation',
      'activeConversationHistory',
      'templateText',
      'userInfo',
    ]),
    isValid() {
      return (this.params && this.params.length === 0 && this.paramsForm === 0)
      || (this.params && this.params.length === this.paramsForm);
    },
    campaignId() {
      if (this.isHistory
        && this.activeConversationHistory
        && this.activeConversationHistory.conversation) {
        return this.activeConversationHistory.conversation.campaign.id;
      }
      if (!this.isHistory
        && this.activeConversation
        && this.activeConversation.conversation) {
        return this.activeConversation.conversation.campaign.id;
      }
      return null;
    },
    conversation() {
      return !this.isHistory
        ? this.activeConversation.conversation
        : this.activeConversationHistory.conversation;
    },
    client() {
      return !this.isHistory
        ? this.activeConversation.client
        : this.activeConversationHistory.client;
    },
    channel() {
      return this.conversation.channel;
    },
    labels() {
      return !this.isHistory
        ? this.activeConversation.client.labels
        : this.activeConversationHistory.client.labels;
    },
    quickText() {
      return this.templateText({
        campaignId: this.selectedCampaign,
      });
    },
    paramsForm() {
      if (this.selectMessage
        && this.selectMessage.settings
        && this.selectMessage.settings.num_params) {
        return parseInt(this.selectMessage.settings.num_params, 10);
      }
      return 0;
    },
    parseText() {
      if (this.selectMessage) {
        let { text } = this.selectMessage;
        this.params.forEach((param, index) => {
          const re = `{{${index + 1}}}`;
          text = text.replace(re, param);
        });
        return text;
      }
      return null;
    },
    modalText() {
      return this.$t('chat-multimedia-modal');
    },
    isEmpty() {
      return this.quickText.length === 0;
    },
  },
  methods: {
    selectElement(quickText) {
      this.selectMessage = quickText;
      this.showConfirmation();
    },
    reset() {
      this.selectMessage = null;
      this.params = [];
    },
    onConfirm() {
      this.$modal.show('send-template-modal');
    },
    onConfirmSend() {
      const msg = {
        tempId: this.uuidv4(),
        typeUser: 'User',
        user: this.userInfo,
        type: this.type.text,
        text: this.parseText,
        clientId: this.client.id,
        channelId: this.channel.id,
        campaignId: this.selectedCampaign,
        template: {
          id: this.selectMessage.id,
          params: this.params,
        },
      };

      EventBus.$emit(CHAT_SEND_MESSAGE, msg, true);
      EventBus.$emit(CHAT_MULTIMEDIA_TOGGLE, false);
    },
    onCloseSend() {
      this.reset();
    },
    getParam(n) {
      return this.$t('chat-multimedia-modal.param', { param: n });
    },
    showConfirmation() {
      this.$modal.show('confirmation', {
        title: this.modalText['send-template'],
        description: this.modalText['confirm-msg'],
        confirm: async () => {
          this.onConfirm();
          await this.$nextTick();
          if (this.paramsForm !== 0) {
            this.$refs.paramsInput[0].focus();
          }
        },
      });
    },
  },
};
</script>
